import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AlertConfigComponent } from './pages/alert-config/alert-config.component';

const routes: Routes = [
  { path: '', component: AlertConfigComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: []
})
export class AlertConfigRoutingModule {}
